// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@400;800&display=swap);"]);
// Module
exports.push([module.id, "#sr-questionnaire .background,.sr-questionnaire .background{position:absolute;z-index:-9;top:0;left:0;width:100%;height:100%}#sr-questionnaire .loader,.sr-questionnaire .loader{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center}#sr-questionnaire .private-questionnaire-info svg,.sr-questionnaire .private-questionnaire-info svg{display:block;margin:auto;margin-bottom:28px;opacity:.6}", ""]);
// Exports
module.exports = exports;
